import React from 'react'
import stripeOptions from '../../services/stripe'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Divider, Icon, Form, Input, Loader, Image, List, Accordion, Modal } from 'semantic-ui-react'
import { backendService } from '../../services/backendService'
import Logo from '../../images/logo-admin.png'
import { updateLawyer, getProjects } from '../../actions/actionCreators'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import BillingInfoForm from '../BillingInfoForm'
import csc from 'country-state-city'
import { NotificationManager } from 'react-notifications';
import CardForm from './CardForm'

const loadScript = src =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.addEventListener('load', () => {
      resolve({ successful: true })
    })
    script.addEventListener('error', event => {
      reject({ error: event })
    })
    document.head.appendChild(script)
  })


class Profile extends React.Component {
  
  stripePromise = null
  
  constructor(){
    super()
    this.getProfile = this.getProfile.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.state = { 
      showCardForm: false,
      processing: false,
      billingInfo: {},
      disabled: true,
      user: {}, 
      showCards: false,
      stripeLoaded : {},
      paymentMethods: [],
      errors: {
        name: '',
        email: '',        
        surname: '',
      }
    }
  }

  componentDidMount () {
    const fetchData = async () => {
      const result = await loadScript('https://js.stripe.com/v3/')
      this.setState({...this.state, stripeLoaded: result})
      this.stripePromise = loadStripe(stripeOptions.api_key);
    }

    window.dataLayer.push({
      event: 'page_view',
      page: {
        url: document.location.pathname,
        title: 'User Profile'
      }
    });

    fetchData()
    this.getProfile()

  }

  handleNameChange(event) {
    event.preventDefault()
    if (event.target.value === '')
      this.setState({errors: {...this.state.errors, name: Translate(this.context,'signup_name_is_required')}})
    else
      this.setState({errors: {...this.state.errors, name: ''}})
      this.setState({ user: { ...this.state.user, name: event.target.value } });
  }

  handleLastNameChange(event) {
    event.preventDefault()
    if (event.target.value === '')
      this.setState({errors: {...this.state.errors, surname: Translate(this.context,'signup_surname_is_required')}})
    else
      this.setState({errors: {...this.state.errors, surname: ''}})
    this.setState({ user: { ...this.state.user, surname: event.target.value } });
  }

  async validateUser() {
    const fieldsErrors = {};
    if (this.state.user.name === '') fieldsErrors.name = Translate(this.context,'signup_name_is_required')
    if (this.state.user.surname === '') fieldsErrors.surname = Translate(this.context,'signup_surname_is_required')    
    return Object.keys(fieldsErrors).length ? fieldsErrors : false;
  };

  async getProfile(){
    await this.setState({ loading:  true} )
    const authorization = backendService.defaults.headers.Authorization;
    const response = await backendService.get('/api/users/me', {authorization})
    if(response && response.data) {
      this.setState({ user: response.data })      
      if (this.props.auth.type === 'user') {
        const stripe_response = await backendService.get('/api/lawyers/' + response.data.id + '/stripe_customer')      
        if (stripe_response && stripe_response.data) {
          const stripe_customer = stripe_response.data
          const billingInfo = {}
          if (stripe_customer.address) {
            billingInfo.address = stripe_customer.address.line1
            billingInfo.address_complement = stripe_customer.address.line2
            billingInfo.state = stripe_customer.address.state
            billingInfo.city = stripe_customer.address.city
            billingInfo.zip_code = stripe_customer.address.postal_code
            billingInfo.country_code = stripe_customer.address.country ? stripe_customer.address.country : 'IT'
            billingInfo.country = csc.getCountryByCode(billingInfo.country_code).id
          }
          if(stripe_customer.tax_ids.data && stripe_customer.tax_ids.data[0])
            billingInfo.vat_number = stripe_customer.tax_ids.data[0].value
          if (stripe_customer.metadata.Pec)
            billingInfo.Pec = stripe_customer.metadata.Pec
          if (stripe_customer.metadata.Fe_code)
            billingInfo.Fe_code = stripe_customer.metadata.Fe_code
          if (stripe_customer.metadata.Fiscal_code)
            billingInfo.Fiscal_code = stripe_customer.metadata.Fiscal_code
          billingInfo.is_invoice = stripe_customer.metadata.is_invoice ? stripe_customer.metadata.is_invoice : billingInfo.vat_number ? 'true' : 'false'
          this.setState({ customerProfile: stripe_customer, billingInfo: billingInfo})        
        }

        const payment_response = await backendService.get('/api/lawyers/' + response.data.id + '/payment_methods')
        if( payment_response && payment_response.data ) {        
          this.setState({ paymentMethods: payment_response.data.data})        
        }
      }
      
    } else {
      NotificationManager.error(Translate(this.context, 'user_profile_load_error'))
    }
    await this.setState({ loading:  false} )
  }

  async updateUser(e) {
    e.preventDefault();
    this.setState({processing: true})
    let validateErrors = await this.validateUser();
    if (validateErrors) {
      this.setState({errors: validateErrors})
    } else {
      const { name, surname, email, disabled, id } = this.state.user;
      let lawyer = {
        name,
        surname,
        email,
        disabled,
      }
      //add billing info
      if (this.state.showBillingInfo) {
        const billingInfo = this.state.billingInfo
        lawyer.address = billingInfo ? {
          line1: billingInfo.address,
          line2: billingInfo.address_complement,
          city: billingInfo.city,
          country: billingInfo.country_code,
          state: billingInfo.state,
          postal_code: billingInfo.zip_code
        } : null
        
        const metadata = billingInfo && billingInfo.is_invoice === 'true' ? 
        {
          Fe_code: billingInfo.Fe_code,
          Pec: billingInfo.Pec,
          is_invoice: 'true'
        } : 
        billingInfo && billingInfo.is_invoice === 'false' ? 
          { Fiscal_code: billingInfo.Fiscal_code,
            is_invoice: 'false'
          } 
          : 
          {}
        
        lawyer.metadata = metadata 

        lawyer.vat_number = billingInfo ? billingInfo.vat_number : null
      }

      this.props.dispatch(updateLawyer(id, lawyer)).then ( () => {
        const message = Translate(this.context, this.props.auth.message) ? Translate(this.context, this.props.auth.message) : this.props.auth.message
        const isError = this.props.auth.error ? this.props.auth.error : false
        if (!isError)
          NotificationManager.success(message)
        else 
          NotificationManager.error(message)
        this.getProfile();   
        this.setState({processing: false})
      })
      return
    }
    this.setState({processing: false})
  }

  handleBillingInfoChanged (info) {
    this.setState({billingInfo: info})
  }

  hasErrors(data) {
    return !data || (data.errors && (data.errors.name !== '' ||
    data.errors.email !== '' ||
    data.errors.surname !== ''))
  }

  updatePaymentMethod(event) {
    event.preventDefault();
    this.setState({showCardForm: true})
  }

  handleCardModalOpen = () => this.setState({ showCardForm: true })

  handleCardModalClose = () => this.setState({ showCardForm: false })

  async handleCardChange(new_payment_method) {
    try {
      //delete old payment methods
      if (this.state.paymentMethods.length > 0) {
        this.state.paymentMethods.forEach( method => {
          if (method.id !== new_payment_method)            
            backendService.delete('/api/lawyers/payment_methods/' + method.id)
        });              
      }
      //update subscriptions to use new payment method
      if (this.state.customerProfile && 
          this.state.customerProfile.subscriptions && 
          this.state.customerProfile.subscriptions.data && 
          this.state.customerProfile.subscriptions.data.length > 0) {            
        this.state.customerProfile.subscriptions.data.forEach( subscription => {    
            backendService.put('/api/lawyers/' + this.state.user.id + '/subscriptions/' + subscription.id, { default_payment_method:  new_payment_method })
        }); 
      }
    } catch(exc) {

    }
    this.getProfile();            
    this.setState({ showCardForm: false })       
    return true;
  }

  async preventReturnPropagation(event) {
    if (event.keyCode === 13)
      event.preventDefault()
  }

  render() {
    const user = this.state.user
    const cardsStripe = this.state.paymentMethods
    const billingInfo = this.state.billingInfo
    const cards = this.state.user.customerid && cardsStripe && cardsStripe.length > 0 ? cardsStripe.map((card, index) =>
      <List.Item key={index}>              
        <Form.Input   
          type="text" 
          name="card" 
          placeholder=''
          value={`**** **** **** ${card.card.last4}`} 
          action={{
            style: {background: '#3e4ad4', color: 'white'},
            icon: 'edit',
            content: card.card.brand,
            labelPosition: 'right',
            onClick: this.updatePaymentMethod.bind(this)
          }}
        /> 
      </List.Item>
    ) : null
    return (
        <>
          <Row>  
            <Col xs={8} sm={4} md={3} className='lisia-app-logo-wrapper'>
              <Link to='/'>
                <Image src={ Logo } />
              </Link>
            </Col>
          </Row>
          <Row>
            <Col className="profile-content lisia-app-card-content centered" xs={12} md={10}>      
             
              <div className='lisia-app-header'> 
                <div className='header'>                            
                </div>                      
                <h3 className='text-center  lisia-app-card-title'><Text tid="user_profile_your_profile" /></h3>
              </div>
              <Divider />
              {this.state.loading &&
                <Loader active inline='centered' className='marginLoadMore' />
              }  
              {!this.state.loading && 
                <>  
                  <Form onSubmit={this.updateUser.bind(this)}>               
                    <Form.Group widths='equal'>
                      <Form.Field>
                        <label><Text tid="user_profile_first_name" /></label>
                        <Form.Input
                          autoComplete="first-name"
                          value={user.name ? user.name : ''}                     
                          onChange={this.handleNameChange.bind(this)}
                          onKeyDown={this.preventReturnPropagation.bind(this)}
                          error={this.state.errors.name !== '' ? this.state.errors.name : false}
                          name="firstName"
                          type="text" placeholder={Translate(this.context,'user_profile_first_name')} />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field>
                        <label><Text tid="user_profile_last_name" /></label>
                        <Form.Input
                          autoComplete="family-name"
                          onChange={this.handleLastNameChange.bind(this)}
                          onKeyDown={this.preventReturnPropagation.bind(this)}
                          value={user.surname ? user.surname : ''}
                          error={this.state.errors.surname !== '' ? this.state.errors.surname : false}
                          name="lastName"
                          type="text" placeholder={Translate(this.context,'user_profile_last_name')} />
                      </Form.Field>
                      </Form.Group>
                      <Form.Group widths='equal'>
                      <Form.Field>
                        <label><Text tid="email" /></label>
                        <Input
                          autoComplete="email"
                          disabled={true}
                          value={user.email ? user.email : ''}
                          onKeyDown={this.preventReturnPropagation.bind(this)}
                          name="email" 
                          type="email" placeholder={Translate(this.context,'user_profile_email')} />
                      </Form.Field>
                    </Form.Group>

                    { this.state.user.customerid &&
                      <Accordion>
                        <Accordion.Title
                          active={this.state.showCards}
                          index={0}
                          onClick={() => this.setState({showCards: !this.state.showCards})}
                          style={{textAlign:'left', fontSize: this.state.showCards ? '1.17em': '', fontWeight: 'bold'}}
                        >
                        <Icon name='dropdown' />      
                        {
                          this.state.showCards ? 
                          <div style={{textAlign: 'center', marginTop: '-1.17em'}}>
                            <Text tid='user_profile_payment_methods' />
                          </div>
                          : <Text tid='user_profile_show_payment_methods' />
                        }                                     
                        </Accordion.Title>
                        <Accordion.Content active={this.state.showCards} style={{margin: '10px'}}>     
                          <Divider />  
                          { cards ?             
                            <List>
                              {cards}
                            </List> 
                            : 
                            <Form.Input   
                              type="text" 
                              name="card" 
                              placeholder=''
                              value={Translate(this.context, 'subscription_payment_method_missing')}
                              action={{
                                style: {background: '#3e4ad4', color: 'white'},
                                icon: 'add',
                                content: Translate(this.context, 'add_card'),
                                labelPosition: 'right',
                                onClick: this.updatePaymentMethod.bind(this)
                              }}
                            />                       
                          }
                        </Accordion.Content>
                      </Accordion> 
                    }     
                    { this.state.user.customerid &&
                      <Accordion>
                        <Accordion.Title
                          active={this.state.showBillingInfo}
                          index={0}
                          onClick={() => this.setState({showBillingInfo: !this.state.showBillingInfo})}
                          style={{textAlign:'left', fontSize: this.state.showBillingInfo ? '1.17em': '', fontWeight: 'bold'}}
                        >
                          <Icon name='dropdown' />     
                          {
                            this.state.showBillingInfo ? 
                            <div style={{textAlign: 'center', marginTop: '-1.17em'}}>
                              <Text tid='user_profile_billing_info' /> 
                            </div>
                            : <Text tid='user_profile_show_billing_info' />
                          }                                          
                        </Accordion.Title>
                        { this.state.showBillingInfo &&
                          <Accordion.Content active={this.state.showBillingInfo} style={{margin: '10px'}}>     
                            <Divider />              
                            <BillingInfoForm handleStateChange={this.handleBillingInfoChanged.bind(this)} billingInfo={billingInfo} /> 
                          </Accordion.Content>
                        }
                      </Accordion> 
                    }                       
                    <Button className='lisia-blue' disabled = {this.state.processing || this.hasErrors(this.state) || (this.state.showBillingInfo && (this.state.billingInfo.is_error || !this.state.billingInfo.is_data_ok))} style={{width: '100%'}} type="submit"><Text tid="save" /></Button>
                    <Modal                  
                      open={this.state.showCardForm}
                      onClose={this.handleCardModalClose}
                      onOpen={this.handleCardModalOpen}
                      style={{maxWidth: '500px', minWidth: '320px'}}
                    >
                      <Modal.Content>
                        <h3 className='text-center'><Text tid='subscription_payment_method_title' /></h3>
                        <Divider />
                        <p className='text-center'><Text tid='subscription_update_payment_method_description' /></p>                    
                        { this.state.stripeLoaded.successful &&
                            <Elements stripe={this.stripePromise} locale={this.context.language.id}>
                              <CardForm customerId={this.state.user.customerid} handleResult={this.handleCardChange.bind(this)} />
                            </Elements>
                        }
                      </Modal.Content>
                      <Modal.Actions>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                          <Link onClick={this.handleCardModalClose} to='#'>
                              <Text tid="back" />
                          </Link>                  
                        </div>
                      </Modal.Actions>
                    </Modal>

                    <Divider />
                    <div className='footer' >
                      <Link to='/'>
                        <Text tid="back" />
                      </Link>
                      <Link to="/updatepassword">
                        <Text tid="change_password_button" />
                      </Link>
                    </div>
                  </Form>
                </>
              }
            </Col>
          </Row>   
        </>  
    )
  }
}

Profile.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  auth: state.auth
})

Profile.contextType = LanguageContext;

export default connect(mapStateToProps)(Profile)

